import { render, staticRenderFns } from "./file-container-card.vue?vue&type=template&id=11c09a0c&scoped=true&"
import script from "./file-container-card.vue?vue&type=script&lang=js&"
export * from "./file-container-card.vue?vue&type=script&lang=js&"
import style0 from "./file-container-card.vue?vue&type=style&index=0&id=11c09a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c09a0c",
  null
  
)

export default component.exports